import React, { useState, useEffect } from "react";
import { Table, TableColumn } from "../../../../components/table";
import HeaderBar from "../../../../components/header/headerBar";
import MainButton from "../../../../components/button/mainButton";
import Icon from "@mdi/react";
import { mdiPencilCircle, mdiDelete, mdiPlusCircle } from "@mdi/js";
import JobCreateModal from "../../../../components/modal/jobCreateModal";
import { SearchField } from "../../../../components/textfield";
import SucceedModal from "../../../../components/modal/succeedModal";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import axios from "axios";

const JobGroup = () => {
  interface ParamTypes {
    id: string;
  }

  const { id } = useParams<ParamTypes>();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenJob, setIsOpenJob] = useState(false);
  const [jobCategory, setJobCategory] = useState<any>([]);
  // const [deleteJobData, setDeleteJobData] = useState<any>([]);
  const [jobs, setJobs] = useState([]);
  const columns = [
    {
      title: "",
    },
    {
      title: "ชื่อตำแหน่งงาน",
    },
    {
      title: "ค่ามือ (บาท , %) ",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];
  const data = [
    {
      list: "Therapist",
      handValue: "50.00",
    },
    {
      list: "คลีนหน้า/Clean",
      handValue: "100.00",
    },
    {
      list: "แปะยาชา",
      handValue: "50.00",
    },
    {
      list: "ล้างแผล/Dressing",
      handValue: "50.00",
    },
    {
      list: "Anesthiologist",
      handValue: "100.00",
    },
    {
      list: "Assistant Anesth",
      handValue: "100.00",
    },
    {
      list: "Scrub Nurse",
      handValue: "50.00",
    },
    {
      list: "ค่าศัลยแพทย์ Surgeon (Strip)",
      handValue: "40%",
    },
    {
      list: "ค่าศัลยแพทย์ Surgeon (Fue)",
      handValue: "40%",
    },
    {
      list: "Hair Therapist",
      handValue: "50.00",
    },
  ];

  function onClose() {
    setIsOpen(true);
    setTimeout(() => setIsOpen(false), 2000);
  }

  const getData = () => {
    axios.get(`/job-groups/category/?productCategoryId=${id}`).then((res) => {
      setJobCategory(res.data.data);
    });
  };

  const getJobTitleData = () => {
    axios.get(`/job-titles`).then((res) => {
      setJobs(res.data.data);
    });
  };

  const editJobTitle = () => {
    console.log("jobCategory =>", jobCategory);
    axios
      .patch(`/job-groups/category/?productCategoryId=${id}`, {
        data: jobCategory,
      })
      .then((res) => {
        console.log("res =>", res.data);
      });
  };

  const addData = (data: any) => {
    jobCategory.push({
      jobTitle: data,
    });
  };

  const deleteJobTitle = (dataId: any) => {
    let deleteData = [];
    for (const [index, value] of jobCategory.entries()) {
      console.log("value ==>", value);
      if (value.jobTitle._id !== dataId) {
        deleteData.push({
          jobTitle: value.jobTitle,
        });
      }
    }
    setJobCategory(deleteData);
  };

  function onCloseJob() {
    setIsOpenJob(false);
  }

  useEffect(() => {
    getData();
    getJobTitleData();
  }, []);

  return (
    <div>
      <HeaderBar title="JOB GROUP / CREATE" btnBack={true} />
      <div style={{ padding: "10px 40px" }}>
        <JobCreateModal show={isOpenJob} onClose={onCloseJob} width="90%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <div
              className="header-bar"
              style={{ backgroundColor: "unset", padding: "unset" }}
            >
              <p>เลือกรายการ</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <SearchField
                placeholder="Search for Stock (Code, Name)"
                color="#fff"
              />
            </div>
            <Table header={columns}>
              {jobs.map((item: any, index: number) => (
                <tr key={index} style={{ cursor: "pointer" }}>
                  <TableColumn width="3%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="50%">{item.name}</TableColumn>
                  <TableColumn width="13%" align="center">
                    {item.handFee.toFixed(2)}
                  </TableColumn>
                  <TableColumn width="13%" align="center">
                    {item._id}
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    <div
                      onClick={() => {
                        addData(item);
                      }}
                    >
                      <Icon path={mdiPlusCircle} size="30" color="#5BAEA9" />
                    </div>
                  </TableColumn>
                </tr>
              ))}
            </Table>
          </div>
        </JobCreateModal>
        <SucceedModal
          show={isOpen}
          title="บันทึกข้อมูล JOB เรียบร้อยแล้ว"
        ></SucceedModal>
        <div className="row">
          <div
            className="col-6 header-bar"
            style={{ display: "flex", justifyContent: "left" }}
          >
            <p>AESTHETIC</p>
          </div>
          <div
            className="col-6"
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "20px",
            }}
          >
            <MainButton
              title="เลือกรายการ"
              onClick={() => {
                setIsOpenJob(true);
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {jobCategory.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="50%">{item.jobTitle.name}</TableColumn>
                <TableColumn width="15%" align="center">
                  {item.jobTitle.handFee.toFixed(2)}
                </TableColumn>
                <TableColumn
                  width="5%"
                  align="center"
                  onClick={() => {
                    deleteJobTitle(item.jobTitle._id);
                  }}
                >
                  <Icon path={mdiDelete} size="25" color="#FF6760"></Icon>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
        <div className="justify-center mt-20">
          <MainButton
            className="mg-10"
            background="#E76464"
            title="ยกเลิก"
            onClick={() => history.push(`/setting/job/group`)}
          />
          <MainButton
            className="mg-10"
            title="บันทึกข้อมูล"
            onClick={() => {
              editJobTitle();
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default JobGroup;
